import { render, staticRenderFns } from "./Amenity2.vue?vue&type=template&id=0e3e49f0&"
import script from "./Amenity2.vue?vue&type=script&lang=js&"
export * from "./Amenity2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports